import axios from 'axios';

export default {
    methods: {
        async familiaSelect(empresa_id, ok, err) {
            try {
                let r = await axios.post('familia/select', {empresa_id: empresa_id})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/familia.js